import { Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CustomFieldServiceService implements OnInit {
    typeOf: any;
    customFieldForm: FormGroup = this._formBuilder.group({
        name: ['', Validators.required],
        isVisible: ['visible', Validators.required],
        fallbackText: [''],
    });
    backupFields: any;
    allFields: any;
    updateField: any;
    activeTabInd: any = 0;
    customField: any = [];
    filterCustomField: any[] = [];
    private paginator: MatPaginator;
    notSelectedMapping: any[] = [];
    allMappingKeys: any[] = [];
    private focusSubject = new Subject<void>();
    focus$ = this.focusSubject.asObservable();
    constructor(private _formBuilder: FormBuilder) {}
    ngOnInit(): void {}
    get form() {
        return this.customFieldForm.controls;
    }

    updatePagination(data) {
        console.log({data});
        if (this.paginator) {
            data.paginator = this.paginator;
            this.paginator._changePageSize(this.paginator.pageSize);
            console.log('after pagination update', data);
        }
    }

    focus() {
        this.focusSubject.next();
      }
}
